module.exports = __webpack_public_path__ + "img/Banner-Web_1370.dbe70fa3.jpg";